// extracted by mini-css-extract-plugin
module.exports = {"button":"buttons_button__2ENdU","inline":"buttons_inline__1RqzW","disabled":"buttons_disabled__1wn9n","loading":"buttons_loading__SOfrm"};